import { Route, Navigate, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { AutoSignin } from './AutoSignin';
import { PrivateRoute } from './PrivateRoute';
import { RoleGuard } from './RoleGuard';

import { App } from '../App';
import { ErrorBoundary } from '../design-system';
import {
  ErrorPage,
  ConstructionPage,
  SignIn,
  Dashboard,
  DashboardMenu,
  Containers,
  ContainersSetLocation,
  GateInsAddWithImage,
  GateOutsLoaded,
  GateOutsComplete,
  GateOutsAdd,
  GateOutsFilters,
  RepairsGroup,
  Repairs,
  RepairsAdd,
  Inventory,
  InventoryCheck,
} from '../pages';
import { MESSAGES } from '../const';

export const originalRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        element={
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        }
        errorElement={
          <ErrorPage
            heading={MESSAGES.ERROR_BOUNDARY.HEADING}
            detail={MESSAGES.ERROR_BOUNDARY.DETAIL}
            navigateTo={-1}
          />
        }
      >
        <Route element={<AutoSignin />}>
          <Route index path={'signin'} element={<SignIn />} />
          <Route path={'dashboard'} element={<PrivateRoute Component={Dashboard} />}>
            <Route index element={<DashboardMenu />} />
            <Route
              path={'containers'}
              element={
                <RoleGuard
                  roles={[
                    'SUPER_ADMIN',
                    'YARD_COMPANY_ADMIN',
                    'YARD_COMPANY_EMPLOYEE',
                    'YARD_MANAGER',
                    'YARD_DISPATCHER',
                  ]}
                >
                  <Containers />
                </RoleGuard>
              }
            />
            <Route
              path={'gateins/add'}
              element={
                <RoleGuard
                  roles={[
                    'SUPER_ADMIN',
                    'YARD_COMPANY_ADMIN',
                    'YARD_COMPANY_EMPLOYEE',
                    'YARD_MANAGER',
                    'YARD_DISPATCHER',
                  ]}
                >
                  <GateInsAddWithImage />
                </RoleGuard>
              }
            />
            <Route
              path={'containers/set-location'}
              element={
                <RoleGuard roles={['YARD_CRANE_OPERATOR']}>
                  <ContainersSetLocation />
                </RoleGuard>
              }
            />
            <Route
              path={'gateouts/filters'}
              element={
                <RoleGuard
                  roles={[
                    'SUPER_ADMIN',
                    'YARD_COMPANY_ADMIN',
                    'YARD_COMPANY_EMPLOYEE',
                    'YARD_MANAGER',
                    'YARD_DISPATCHER',
                    'YARD_CRANE_OPERATOR',
                  ]}
                >
                  <GateOutsFilters />
                </RoleGuard>
              }
            />
            <Route
              path={'gateouts/loaded'}
              element={
                <RoleGuard roles={['YARD_CRANE_OPERATOR']}>
                  <GateOutsLoaded />
                </RoleGuard>
              }
            />
            <Route
              path={'gateouts/complete'}
              element={
                <RoleGuard
                  roles={[
                    'SUPER_ADMIN',
                    'YARD_COMPANY_ADMIN',
                    'YARD_COMPANY_EMPLOYEE',
                    'YARD_MANAGER',
                    'YARD_DISPATCHER',
                  ]}
                >
                  <GateOutsComplete />
                </RoleGuard>
              }
            />
            <Route
              path={'gateouts/add'}
              element={
                <RoleGuard roles={'client'}>
                  <GateOutsAdd />
                </RoleGuard>
              }
            />
            <Route
              path={'repairs'}
              element={
                <RoleGuard roles={'admin'}>
                  <RepairsGroup />
                </RoleGuard>
              }
            />
            <Route
              path={'repairs/add'}
              element={
                <RoleGuard roles={'admin'}>
                  <RepairsAdd />
                </RoleGuard>
              }
            />
            <Route
              path={'repairs/:id'}
              element={
                <RoleGuard roles={'admin'}>
                  <Repairs />
                </RoleGuard>
              }
            />
            <Route
              path={'inventory'}
              element={
                <RoleGuard roles={['YARD_MANAGER', 'YARD_DISPATCHER', 'YARD_CRANE_OPERATOR']}>
                  <Inventory />
                </RoleGuard>
              }
            />
            <Route
              path={'inventory/:id/check'}
              element={
                <RoleGuard roles={['YARD_MANAGER', 'YARD_DISPATCHER', 'YARD_CRANE_OPERATOR']}>
                  <InventoryCheck />
                </RoleGuard>
              }
            />
            <Route index path={'*'} element={<Navigate to={'/dashboard'} replace />} />
          </Route>
          <Route path={'*'} element={<Navigate to={'/signin'} replace />} />
        </Route>
      </Route>
      <Route path={'*'} element={<Navigate to={'/signin'} replace />} />
    </>,
  ),
);

const constructionRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route index element={<ConstructionPage />} />
      <Route path={'*'} element={<Navigate to={'/'} replace />} />
    </>,
  ),
);

export const router =
  process.env.REACT_APP_IS_CONSTRUCTION === 'true' ? constructionRouter : originalRouter;
